import { TravelAnalyticsService } from "./TravelAnalyticsService";

export const travelAnalyticsService = new TravelAnalyticsService();
export * from "./ITravelAnalyticsService";
